import CustomTextarea from './CustomTextarea.vue'
export default CustomTextarea


// WEBPACK FOOTER //
// ./src/components/CustomTextarea/index.js